import { withConfig } from "@/utils/withConfig";
import { BankDetails } from "./BankDetails";
import type { BankDetailsProps } from "./BankDetailsProps";

export * from "./BankDetails";
export * from "./BankDetailsProps";

export const BankDetailsWithConfig = withConfig<BankDetailsProps>(
  BankDetails,
  "bank_details",
);
